import { h } from '../lib/dom.js';
import { getState } from '../store.js';
import { iconMarkup } from '../icons/index.js';
import { cancelConfirmReveal, setConfirmRevealCode, submitConfirmReveal, confirmRevealWithWebauthn } from '../actions.js';

export function renderConfirmRevealModal() {
  const s = getState();
  if (!s.showConfirmReveal) return null;
  const profile = s.profiles.find((p) => p.id === s.activeProfileId) || s.profiles[0];
  const canWebauthn = s.webauthnAvailable && profile && profile.vault && profile.vault.webauthn;

  const input = h('input', {
    class: 'code-input',
    value: s.confirmRevealCode,
    placeholder: '6-digit code',
    maxlength: '6',
    inputmode: 'numeric',
    oninput: (e) => setConfirmRevealCode(e.target.value)
  });
  input.addEventListener('keydown', (e) => { if (e.key === 'Enter') submitConfirmReveal(); });

  return h('div', { class: 'modal-scrim' }, [
    h('div', { class: 'modal-card' }, [
      h('div', { class: 'modal-title' }, 'Confirm your passcode'),
      h('div', { class: 'text-muted modal-help' }, 'Enter your passcode to reveal this recovery phrase.'),
      canWebauthn ? h('button', {
        class: 'btn btn-secondary btn-sm full-width', onclick: confirmRevealWithWebauthn
      }, [h('span', { html: iconMarkup('scanFace', { size: 14 }) }), ' Use biometrics instead']) : null,
      input,
      h('div', { class: 'field-error' }, s.confirmRevealError || ''),
      h('div', { class: 'btn-row' }, [
        h('button', { class: 'btn btn-secondary', onclick: cancelConfirmReveal }, 'Cancel'),
        h('button', { class: 'btn btn-primary', onclick: submitConfirmReveal }, 'Reveal')
      ])
    ])
  ]);
}
